import { AxiosError } from 'axios';
import { CreateProjectResponse } from '@shared/types/project.type';
import { ApiError, AxiosApiResponse } from '@app/models/api/api-response.interface';
import api from '../../../../../app/api/axios-api';

const createProject = async (
  userId: string,
  title: string,
  overview: string,
  domain?: string,
  environment?: string
): Promise<AxiosApiResponse<CreateProjectResponse>> => {
  try {
    const requestBody: Record<string, string> = {
      userId,
      title,
      overview
    };

    if (domain) {
      requestBody.domain = domain;
    }

    if (environment) {
      requestBody.environment = environment;
    }

    console.log('Creating project with body:', requestBody);

    const response = await api.post(`project/create-project`, requestBody);
    return { response };
  } catch (error) {
    return { error: error as AxiosError<ApiError> };
  }
};

const updateProject = async (
  userId: string,
  projectId: string,
  updateData: { title?: string; domain?: string; overview?: string }
): Promise<AxiosApiResponse<CreateProjectResponse>> => {
  try {
    const response = await api.put(`project/update-project`, {
      userId,
      projectId,
      ...updateData
    });
    return { response };
  } catch (error) {
    return { error: error as AxiosError<ApiError> };
  }
};
export const ProjectCreateService = {
  createProject,
  updateProject
};
